module.exports = __webpack_public_path__ + "static/img/map1.6d2b9d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map/map1.png
// module id = 5ame
// module chunks = 0